/**
 * @name GoogleCaptcha.Shopping.Entry.js
 * @author Anchor Group : Kalpa
 * @since 2025-02-13
 * @file Add Google Re-Captcha to advanced signup form.
 */
define('GoogleCaptcha.Shopping.Entry',
[
    'GoogleCaptcha.SS2Model',
    'GoogleCaptcha.AdvancedSignup'
], function (
    CaptchaSS2Model,
    GoogleCaptchaAdvancedSignup
) {
    'use strict';
    return {
        mountToApp: function mountToApp(container) {
            var captchaModel = new CaptchaSS2Model();
            captchaModel.fetch({
                async: false,
                data: {}
            }).done(function (resp) {
                if (resp.success) {
                    GoogleCaptchaAdvancedSignup.loadCaptcha(container, resp);
                }
            });
        },
    };
});
